import type { ReactNode } from 'react';

import { Stack } from '@mui/material';

interface StatRowProps {
  children: ReactNode;
}

export const StatRow = ({ children }: StatRowProps) => (
  <Stack direction="row" flexWrap="wrap" spacing={2} sx={{ mb: 3 }}>
    {children}
  </Stack>
);
